// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__-6iQl"};